import React, { useState, useEffect } from 'react';
import AddIcon from '@mui/icons-material/Add';
import {
    Box,
    useTheme,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    Modal,
    TableHead,
    TableRow,
    TextField,
    Button,
    Pagination,
    AppBar,
    IconButton,
    Toolbar,
    Typography
} from '@mui/material';
import Close from '@mui/icons-material/Close';
import dayjs from "dayjs";


// import { callApi } from '../../commonapicall/fetchdata';
// import { API_ENDPOINTS } from '../../../config/api/apiCall"';
// import { tokens } from "../../../theme/theme";
import Searchicon from '@mui/icons-material/Search';
import CustomTableContainer from '../../../Layout/CustomTableContainer';
import MarkAttendance from './MarkAttendance';
import { tokens } from '../../../theme/theme';
import { callApi } from '../../../utils/apiClient';
import { API_ENDPOINTS } from '../../../config/api/apiCall';


const AttendanceOverview = ({ handleBackWinderMachineEntry }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [attendanceData, setAttendanceData] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage] = useState(20); // Records per page

    const [viewAttendance, setViewAttendance] = useState(true);
    const [newAttendance, setNewAttendance] = useState(false);
    const [openDateRangeDialog, setOpenDateRangeDialog] = useState(false);

    const [selected_attendanceData, setSelected_attendanceData] = useState([]);
    const handleOpen = () => {
        setOpenDateRangeDialog(true);
    };


    const [filters, setFilters] = useState({
        employee_fullname: '',
    });


    const handleFilterChange = (event) => {
        const { name, value } = event.target;
        setFilters({ ...filters, [name]: value });
    };


    const handleClose = () => {
        setOpenDateRangeDialog(false);
    };

    useEffect(() => {

        loadEmployeeAttendance();



    }, []);

    const loadEmployeeAttendance = () => {

        const companyid = localStorage.getItem('companyid');

        callApi(API_ENDPOINTS.EMPLOYEE_GET_EMPLOYEE_ATTENDANCE_LIST, 'POST', { 'Content-Type': 'application/json' }, companyid)
            .then(data => {
                if (data?.length) {
                    setAttendanceData(data);
                }
            })
            .catch(error => alert(error.message));
    }




    const handleNewAttendance = () => {
        setViewAttendance(false);
        setNewAttendance(true);
        setSelected_attendanceData([]);
    };



    const handleViewAttendance = () => {
        setViewAttendance(true);
        setNewAttendance(false);
        loadEmployeeAttendance();
    };

    // Compute filtered data based on the filter criteria
    const filteredData = attendanceData.filter((record) =>
        record.employee_fullname.toLowerCase().includes(filters.employee_fullname.toLowerCase())
    );

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = filteredData.slice(indexOfFirstRecord, indexOfLastRecord);

    const handleDetailsClick = (record) => {

        setSelected_attendanceData(record);
        setViewAttendance(false);
        setNewAttendance(true);

    };

    return (
        <>
            {viewAttendance && (
                <Box>
                    <AppBar position="static" sx={{ backgroundColor: "inherit", borderRadius: "0px", height: "48px", justifyContent: "center" }}>
                        <Toolbar>
                            <Typography variant='h4'>Employee Attendance</Typography>
                            <Button size="small" startIcon={<AddIcon />} variant="contained" color="secondary" onClick={handleNewAttendance} sx={{ marginLeft: 'auto', textTransform: 'none' }}>New</Button>
                            <IconButton>
                                <Close fontSize="inherit" style={{ color: "#2196F3" }} onClick={handleBackWinderMachineEntry} />
                            </IconButton>
                        </Toolbar>
                    </AppBar>

                    <Box>
                        <Box
                            gridColumn="span 9"
                            gridRow={"span 2"}
                            alignItems="center"
                            justifyContent="center"
                            padding={1}
                            sx={{
                                maxHeight: {
                                    xs: '72vh', // Extra small devices (phones)
                                    sm: '72vh', // Small devices (tablets)
                                    md: '72vh', // Medium devices (small laptops)
                                    lg: '72vh', // Large devices (desktops)
                                    xl: '89vh', // Extra large devices (large desktops)
                                },
                                overflowY: 'auto', // Add overflowY: 'auto' to enable vertical scrolling
                                '&::-webkit-scrollbar': {
                                    width: '8px',
                                },
                                '&::-webkit-scrollbar-track': {
                                    background: colors.primary[400],
                                    borderRadius: '10px',
                                },
                                '&::-webkit-scrollbar-thumb': {
                                    background: colors.blueAccent[600],
                                    borderRadius: '10px',
                                    '&:hover': {
                                        background: colors.blueAccent[800],
                                    },
                                },
                                '&::-webkit-scrollbar-corner': {
                                    background: colors.primary[700],
                                },


                               
                            }}>
                            <CustomTableContainer colors={colors} >
                                <TableContainer>
                                    <Table size='small' stickyHeader>
                                        <TableHead>
                                            <TableRow>

                                                <TableCell>Employee Name</TableCell>
                                                <TableCell>Attendance Date</TableCell>
                                                <TableCell>Check-In</TableCell>
                                                <TableCell>Check-Out</TableCell>
                                                <TableCell>Duration(mins)</TableCell>
                                                <TableCell>Status</TableCell>
                                                <TableCell>Device</TableCell>
                                                <TableCell>Location</TableCell>
                                                <TableCell>Shift</TableCell>

                                                <TableCell>
                                                    <IconButton onClick={handleOpen}>
                                                        <Searchicon style={{ fontSize: "16px" }} />
                                                    </IconButton>
                                                    <Modal
                                                        open={openDateRangeDialog}
                                                        onClose={handleClose}
                                                        aria-labelledby="modal-modal-title"
                                                        aria-describedby="modal-modal-description"
                                                    >
                                                        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', boxShadow: 24, p: 4, minWidth: 300 }}>
                                                            <TextField
                                                                size='small'
                                                                label="Employee name"
                                                                name="employee_fullname"
                                                                value={filters.employee_fullname}
                                                                onChange={handleFilterChange}
                                                                variant="outlined"
                                                                fullWidth
                                                                margin="normal"
                                                            />

                                                            <Button variant="contained" onClick={handleClose} style={{ marginTop: 10 }}>
                                                                Apply Filter
                                                            </Button>
                                                        </Box>
                                                    </Modal>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {currentRecords.map((record, index) => (
                                                <TableRow key={record.id_attendance}>

                                                    <TableCell>
                                                        <span
                                                            style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                            onClick={() => handleDetailsClick(record)}
                                                        >
                                                            {record.employee_fullname}
                                                        </span>
                                                    </TableCell>
                                                    <TableCell>
                                                        {dayjs(record.attendance_date).format('DD-MMM-YYYY')}
                                                    </TableCell>

                                                    <TableCell>
                                                        {new Date(record.check_in_time).toLocaleTimeString([], {
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                            hour12: true, // Set to false for 24-hour format
                                                        })}
                                                    </TableCell>
                                                    <TableCell>
                                                        {new Date(record.check_out_time).toLocaleTimeString([], {
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                            hour12: true, // Set to false for 24-hour format
                                                        })}
                                                    </TableCell>

                                                    <TableCell sx={{ textAlign: 'right' }}>{record.duration_mins}</TableCell>
                                                    <TableCell>{record.attendance_status}</TableCell>
                                                    <TableCell>{record.device}</TableCell>
                                                    <TableCell>{record.location}</TableCell>
                                                    <TableCell>{record.shift_code}</TableCell>


                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </CustomTableContainer>
                        </Box>

                        <Box display="flex" justifyContent="flex-end" sx={{ mt: 2 }}>
                            <Pagination
                                count={Math.ceil(attendanceData.length / recordsPerPage)}
                                page={currentPage}
                                onChange={(event, value) => setCurrentPage(value)}                            
                            />
                        </Box>

                    </Box>
                </Box>
            )}


            {newAttendance && (
                <MarkAttendance handleViewAttendance={handleViewAttendance} AttendanceDetails={selected_attendanceData} />
            )}
        </>
    );
};

export default AttendanceOverview;
